// import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
// import LineChartTooltip from '../LineChartTooltip/LineChartTooltip';

function ActionOverviewGraph({ actionOverviewData }) {
    return (
        <div className="border rounded-lg border-[#EAEAEA] w-full min-h-[50vh] p-5 flex flex-col gap-4">
            <h1 className="font-semibold text-base">Action Overview</h1>

            <div className="m-auto">
                <h1 className='font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>

            {/* <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    data={actionOverviewData} 
                    margin={{
                        top: 10,
                        right: 20,
                        bottom: 10,
                        left: 10,
                    }}
                >
                    <XAxis 
                        dataKey="dayOfWeek" 
                        tickLine={false} 
                        tickCount={actionOverviewData.length} 
                        tickMargin={15} 
                        type='category' 
                    />

                    <YAxis 
                        tickCount={6} 
                        tickLine={false} 
                        tickMargin={15} 
                        type="number" 
                        domain={[0, 2500]} 
                        width={75}
                    />

                    <Tooltip content={<LineChartTooltip />} />

                    <Line type="monotone" dataKey="totalOrders" stroke="#82ca9d" activeDot={{ r: 8 }} />
                </LineChart>
            </ResponsiveContainer> */}
        </div>
    );
}

export default ActionOverviewGraph;
